import React from 'react';
import { article } from '../../advice/styles';
import { MainLayout } from '../../main-layout';
import { useSelector } from 'react-redux';
import { getSeoH1 } from 'features/page-model/ducks/get-model';
import { SplitDescription } from './split-description';
import { CommonDescription } from './common-description';

export const SpbKredit = () => {
  const h1 = useSelector(getSeoH1);

  return (
    <MainLayout>
      <div className={article}>
        <div className="container service-page">
          <section>
            <div className="row">
              <div className="header">
                <h1>{h1}</h1>
              </div>
            </div>
            <div className="row">
              <div className="service-content">
                <div className="service-section section">
                  <div
                    className="service-section-comp"
                    id="service_section"
                    data-navtitle="ОБЩАЯ ИНФОРМАЦИЯ">
                    <div className="par service-section-parsys parsys">
                      <div className="adaptiveImage parbase section">
                        <img
                          src="https://cdn.lemanapro.ru/lmru/image/upload/v1530793836/fudzi/elbrus/images/servicebigicon/desctop/kredit_d.svg/kredit_d.svg"
                          data-desktopref="https://cdn.lemanapro.ru/lmru/image/upload/v1530793836/fudzi/elbrus/images/servicebigicon/desctop/kredit_d.svg/kredit_d.svg"
                          data-tabletref="https://cdn.lemanapro.ru/lmru/image/upload/v1530793837/fudzi/elbrus/images/servicebigicon/tablet/credit tab.svg/credit tab.svg"
                          data-mobileref="https://cdn.lemanapro.ru/lmru/image/upload/v1527940658/fudzi/elbrus/credit mob.svg/credit mob.svg"
                          className="resize-image"
                        />
                      </div>
                      <div className="store-selector section">
                        <div className="store-selector-all-stores">
                          <span className="lm icon-circle-info store-selector-info"></span>
                          <span className="store-selector-text">
                            Информация по кредитам и кредитам без переплат
                          </span>
                        </div>
                      </div>
                      <div className="text parbase section">
                        <CommonDescription />
                        <p>&nbsp;</p>
                        <div className='text parbase section'>
                        <p>
                          <span className="rte-standard">
                            <b>КРЕДИТ БЕЗ ПЕРЕПЛАТ*</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО, при соблюдении условий кредитования, действует
                            программа «Кредит без переплат» на проекты****: «Кухни», «Хранение», «Ванная
                            комната», «Двери», «Пол», «Коттеджные системы фильтрации воды».
                          </span>
                        </p>
                        <span className="rte-standard accent-topic">
                          Условия по программе «Кредит без переплат:
                        </span>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">
                                  Срок «Кредита без переплат»: 6 или 10 месяцев
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Минимальная сумма проекта: 35&nbsp;000 рублей
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Переплата — 0%</span>
                              </li>
                              <li>
                                <span className="rte-standard">Первоначальный взнос — 0%</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        </div>
                        <p>&nbsp;</p>
                        <div className='text parbase section'>
                        <p>
                          <span className="rte-standard">
                            <b>КРЕДИТ НА БОЛЬЩИЕ ЦЕЛИ ПО НИЗКОЙ СТАВКЕ **</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО (Леруа Мерлен) при соблюдении условий кредитования
                            действует программа «Кредит на большие цели по низкой ставке» на все проекты
                            «Кухни», «Хранение», «Ванная комната», «Двери», «Пол», «Коттеджные системы
                            фильтрации воды».
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard accent-topic">
                            Условия по программе «Кредит на большие цели по низкой ставке»:
                          </span>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">
                                  Срок «Кредита на большие цели по низкой ставке»: 12,18, 24 месяца
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Минимальная сумма проекта: 35&nbsp;000 рублей
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Переплата — 3% при оформлении кредита на 12 месяцев, 9% при оформлении
                                  кредита на 18 месяцев и на 15,5% при оформлении кредита на 24 месяца.
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Первоначальный взнос — 0%</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        </div>
                        <p>&nbsp;</p>
                        <div className="text parbase section">
                          <p>
                            <span className="rte-standard">
                              <b>КРЕДИТ НА ПОКУПКУ ТОВАРОВ ЛЕМАНА ПРО***</b>
                            </span>
                          </p>
                          <p>
                            <span className="rte-standard">
                              Во всех магазинах Лемана ПРО доступны кредитные программы банков-партнёров/МФО
                              на весь ассортимент товаров.
                            </span>
                          </p>
                        </div>
                        <p>
                          <span className="rte-standard">
                            <b>Выберите выгодное условия для покупок</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">Кредит/заём на срок 6-60 месяцев</span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Сумма кредита/займа от 2&nbsp;000 рублей до 1&nbsp;000&nbsp;000 рублей
                                  (точную сумму уточняйте у кредитного специалиста в магазине, минимальная
                                  сумма зависит от выбранного банка)
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Первоначальный взнос от 0%.</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Необходимые документы</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">Паспорт гражданина РФ</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Требования к заёмщику</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            <ul>
                              <li>
                                <span className="rte-standard">Гражданство Российской Федерации</span>
                              </li>
                              <li>
                                <span className="rte-standard">Возврат: от 18 лет</span>
                              </li>
                              <li>
                                <span className="rte-standard">
                                  Постоянная регистрация на территории Российской Федерации
                                </span>
                              </li>
                              <li>
                                <span className="rte-standard">Постоянное место работы</span>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <p>&nbsp;</p>
                        <div className="text parbase section">
                          <p>
                            <span className="rte-standard">
                              <b>ОПИСАНИЕ ПРОЕКТОВ****:</b>
                            </span>
                          </p>
                        </div>
                        <p>
                          <span className="rte-standard">
                            <b>Проект «Ванная комната»</b> – это список товаров и услуг для обустройства помещения санузла, который формируется
                            при взаимодействии специалиста по проектным продажам ООО «ЛЕ МОНЛИД» и клиентом в программе Pre-Sale. Данный
                            перечень товаров является результатом визуализации дизайна обустройства ванной комнаты.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Ванная комната» должен включать товары следующих подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              «0601 Керамическая плитка или Керамогранит для облицовки стен» или «0621 Керамическая плитка» или
                              «Керамогранит для облицовки пола» или «0611 мозаика для облицовки стен и пола» «Плитка 0621» или
                              «0640 керамическая плитка и керамогранит для облицовки любых видов поверхностей»
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «0651 товары для укладки плитки: клей для укладки плитки, затирка»
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              “0705 Душевые ограждения и поддоны для ванных комнат” или “0715 Унитаз напольный или унитаз с инсталляцией” или “0725 Ванны и ширмы”,
                            </span>
                          </li>
                        </ul>
                        <span className="rte-standard">далее – «проект Ванная комната».</span>
                        <p>
                          <span className="rte-standard">
                            <b>Проект «Кухни»</b> – это список товаров для обустройства кухни, который формируется при взаимодействии специалиста по проектным продажам ООО «ЛЕ МОНЛИД» 
                            и клиентом в программе Pre-Sale. Данный перечень товаров является результатом визуализации дизайна обустройства кухни.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Кухни» должен включать товары следующих подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              “1510 - Корпуса кухонные” и “1520 - Фасады кухонные” и “1525 – Фурнитура
                              кухонная”
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              “1530 – Столешницы” и/или “1550 – Мойки” и/или “1560 – Смесители”,
                            </span>
                          </li>
                        </ul>
                        <span className="rte-standard">далее – «проект Кухни».</span>

                        <p>
                          <span className="rte-standard">
                            <b>Проект «Хранение»</b> – это список товаров, который формируется при покупке систем хранения Лион, либо сетчатых систем хранения Larvij, либо сетчатых систем
                            хранения HCX, либо сетчатых систем хранения ТИТАН-GS, который формируется при взаимодействии специалиста по проектным продажам ООО «ЛЕ МОНЛИД» и клиентом в 
                            программе Pre-Sale. Данный перечень товаров является результатом визуализации дизайна обустройства жилого помещения.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Хранение» должен включать товары следующих подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">«Модульные шкафы 1415.5»</span>
                            <br />
                            <span className="rte-standard">и/или</span>
                          </li>
                          <li>
                            <span className="rte-standard">«Гардеробные системы 1415. 15»,</span>
                          </li>
                        </ul>
                        <span className="rte-standard">далее – «проект Хранение».</span>

                        <p>
                          <span className="rte-standard">
                            <b>Проект «Пол»</b> – это список товаров, который формируется при покупке
                            артикулов, относящихся к элементам укладки пола.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Пол» должен включать товары следующих подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              «601 ПЛИТКА НАСТЕННАЯ» и/или «611 АКСЕССУАРЫ И МОЗАИКА» и/или «621 НАПОЛЬНАЯ
                              ПЛИТКА» и/или «631 ТЕХНИЧЕСКАЯ ПЛИТКА» и/или «641 ЛЕСТНИЦЫ И ФАСАДЫ» и/или «651 УКЛАДКА И УХОД»
                            </span>
                            <br />
                            <span className="rte-standard">и/или</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «510 КОВРОВЫЕ ПОКРЫТИЯ» и/или «511 ИСКУССТВЕННЫЙ ГАЗОН» и/или «520 КОВРЫ» и/или
                              «521 КОВРИКИ ГРЯЗЕЗАЩИТНЫЕ» и/или «523 КОВРИКИ ДЕКОРАТИВНЫЕ»
                            </span>
                            <br />
                            <span className="rte-standard">и/или</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «515 ЛИНОЛЕУМ» и/или «516 ПВХ ПЛИТКА» и/или «526 ПЛИНТУС» и/или «527 ПОДЛОЖКА»
                              и/или «528 ПОРОГИ» и/или «529 КЛЕЯ» и/или «530 ПАРКЕТ,МАССИВ,ПРОБКА» и/или «532
                              ЛАМИНАТ»
                            </span>
                            <br />
                            <span className="rte-standard">и/или</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «350 ТЕПЛЫЙ ПОЛ»
                            </span>
                          </li>
                        </ul>
                        <span className="rte-standard">далее – «проект «Пол».</span>

                        <p>
                          <span className="rte-standard">
                            <b>Проект «Двери»</b> – это список товаров и услуг для обустройства помещения
                            жилья, который формируется при взаимодействии специалиста по проектным продажам
                            ООО «ЛЕ МОНЛИД» и клиентом в программе Pre-Sale.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Двери» должен включать товары следующих подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              «225.10 Двери межкомнатные ДП Эмаль, Б/отделки, 225.110 Двери межкомнатные ДП
                              Алюм.кромка, 225.120 Двери межкомнатные ДП Скрытого монтажа, 225.140 Двери
                              межкомнатные Межкомнатные двери ПРО, 225.20 Двери межкомнатные ДП шпон, 225.30
                              Двери межкомнатные ДП Ламинированные, 225.40 Двери межкомнатные ДП Массив
                              дерева»
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «225.60 Двери межкомнатные Дверн Комплектующие» «225.10 Двери межкомнатные ДП
                              Эмаль, Б/отделки, 225.110 Двери межкомнатные ДП Алюм.кромка, 225.120 Двери
                              межкомнатные ДП Скрытого монтажа, 225.140 Двери межкомнатные Межкомнатные двери
                              ПРО, 225.20 Двери межкомнатные ДП шпон, 225.30 Двери межкомнатные ДП
                              Ламинированные, 225.40 Двери межкомнатные ДП Массив дерева»
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «225.80 Двери межкомнатные Раздвижные системы» «225.10 Двери межкомнатные ДП
                              Эмаль, Б/отделки, 225.110 Двери межкомнатные ДП Алюм.кромка, 225.120 Двери
                              межкомнатные ДП Скрытого монтажа, 225.140 Двери межкомнатные Межкомнатные двери
                              ПРО, 225.20 Двери межкомнатные ДП шпон, 225.30 Двери межкомнатные ДП
                              Ламинированные, 225.40 Двери межкомнатные ДП Массив дерева»
                            </span>
                            <br />
                            <span className="rte-standard">и</span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «225.60 Двери межкомнатные Дверн Комплектующие»
                            </span>
                            <br />
                            <span className="rte-standard">и/или</span>
                          </li>
                          <li>
                            <span className="rte-standard">«210 Входные двери»</span>
                          </li>
                        </ul>
                        <span className="rte-standard">далее – «проект Двери».</span>

                        <p>
                          <span className="rte-standard">
                            <b>Проект «Коттеджные системы фильтрации воды»</b> – это список товаров и услуг
                            для обустройства систем водоподготовки.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            Проект «Коттеджные системы фильтрации воды» должен включать товары следующих
                            подотделов:
                          </span>
                        </p>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              «8:820:35:10 Соль» - таблетированная соль для регенерации ионообменных смол в
                              системах водоочистки
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «8:820:35:20 Засыпки» - специальный наполнитель, который удаляет загрязняющие
                              вещества из воды
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «8:820:35:30 Головы» - устройство, которое регулирует процессы промывки
                              фильтров и регенерации фильтрующей загрузки в системах фильтрации
                            </span>
                          </li>
                          <li>
                            <span className="rte-standard">
                              «8:820:35:40 Колонны» - часть системы где размещаются фильтрующие материалы,
                              которые удаляют железо, жёсткость и другие загрязнители
                            </span>
                            <br />
                          </li>
                        </ul>

                        <span className="rte-standard">
                          Или следующего подотдела, в случаях когда приобретается кабинетная система
                          фильтрации
                        </span>
                        <ul>
                          <li>
                            <span className="rte-standard">
                              «8:820:35:40 Кабинетные» - это компактное устройство, которое объединяет
                              фильтрующий элемент и корпус в одном устройстве.
                            </span>
                          </li>
                        </ul>
                        <span className="rte-standard">
                          далее – «проект Коттеджные системы фильтрации воды».
                        </span>

                        <p>
                          <span className="rte-standard">
                            <b>* Кредит/заём без переплат.</b>
                          </span>
                          <br />
                          <span className="rte-standard">
                            «Кредиты/ займы без переплат»* предоставляют: АО «Кредит Европа Банк (Россия)»,
                            универсальная лицензия ЦБ РФ на осуществление банковских операций № 3311 от
                            03.09.2019 г.; КБ «Ренессанс Кредит» (ООО), лицензия Банка России на
                            осуществление банковских операций № 3354 от 26.04.2013 г.; АО «ОТП Банк»,
                            лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.;
                            Регистрационный номер записи в государственном реестре микрофинансовых
                            организаций №651503045006297 от 16.02.2015 г; АО «Банк Русский Стандарт» лицензия ЦБ РФ № 2289 от
                            04.09.2024.
                          </span>
                          <br />
                          <span className="rte-standard">
                            В рамках акции «Кредит/ заем без переплат» по итогам проверки заёмщика: диапазон
                            значений полной стоимости кредита/ займа от 24,9% до 25,67%, процентная ставка по
                            кредиту/ займу составляет: при установлении нескольких ставок для разных периодов
                            срока кредита/ займа - от 24,9% до 25,67% (для кредитов в АО «Кредит Европа Банк
                            (Россия); от 24,9% до 25% (для кредитов в КБ «Ренессанс Кредит» (ООО), АО «ОТП
                            Банк»), срок кредита/ займа от 6 месяцев до 10 месяцев, сумма кредита/ займа от 2
                            тыс. 500 рублей до 500 тыс. рублей (для кредитов в АО «Кредит Европа Банк
                            (Россия)»; срок кредита/ займа 6, 10 месяцев сумма кредита/ займа от 5 тыс.
                            рублей до 1 млн.. рублей (для кредитов в КБ «Ренессанс Кредит» (ООО); срок
                            кредита/ займа 6, 10 месяев сумма кредита/ займа 2 тыс. руб. до 300 тыс. рублей
                            (для кредитов АО «ОТП Банк»,); при установлении нескольких ставок для разных периодов срока кредита/ займа – от 25%
                            до 25%, срок кредита 6,10 месяцев, сумма кредита от 3 тыс. рублей до 299 тыс.
                            рублей (для АО «Банк Русский Стандарт»);
                          </span>
                          <br />
                          <span className="rte-standard">
                            Погашение задолженности осуществляется ежемесячными платежами, исходя из срока
                            предоставленного кредита/ займа в соответствии с условиями договора кредита/
                            займа.
                          </span>
                          <br />
                          <span className="rte-standard">
                            * Кредит/ заем без переплат означает, что при приобретении товара с
                            использованием кредитных/ заемных средств указанных банков-партнеров/МФК OOО «ЛЕ
                            МОНЛИД» (ИНН5029069967) предоставляет покупателю скидку на приобретаемый товар от
                            7.0% до 9,8%, в результате чего сумма кредита/ займа, выплачиваемая покупателем
                            банку-партнеру/МФК с учетом суммы процентов, не превышает первоначальной
                            стоимости товара, при условии, что погашение кредита/ займа осуществляется
                            покупателем в соответствии с графиком платежей, без просрочек, дополнительные
                            услуги банков-партнеров/МФК не приобретаются. Специальное предложение по оплате
                            товаров за счет кредитных/ заемных средств, предоставляемых
                            банками-партнерами/МФК, распространяется на товары из отделов: Ванная комната
                            (отделы Сантехника и Плитка), Кухни, Хранение, Напольные покрытия,
                            Входные/межкомнатные двери (отдел Столярные изделия), Электротовары,
                            Водоснабжение. Подробные условия можно уточнить у продавцов-консультантов и в
                            кредитном отделе.
                          </span>
                          <br />
                          <span className="rte-standard">
                            Правила и условия предоставления кредитов/займов Банками-партнерами в местах
                            оформления кредита/ займа или на сайтах Банков-партнеров www.crediteurope.ru,
                            www.rencredit.ru, www.otpbank.ru, www.otpfinance.ru
                          </span>
                          <br />
                          <span className="rte-standard">
                            Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения
                            причин отказа. Информация не является офертой.
                          </span>
                        </p>

                        <p>
                          <span className="rte-standard">
                            <b>** Кредит на большие цели по низкой ставке.</b>
                          </span>
                          <br />
                          <span className="rte-standard">
                            {' '}
                            «Кредит на большие цели по низкой ставке»* предоставляют: АО «Кредит Европа Банк
                            (Россия)», универсальная лицензия ЦБ РФ на осуществление банковских операций №
                            3311 от 03.09.2019 г.; КБ «Ренессанс Кредит» (ООО), лицензия Банка России на
                            осуществление банковских операций № 3354 от 26.04.2013 г.; АО «ОТП Банк»,
                            лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.; АО «Банк Русский Стандарт»
                            лицензия ЦБ РФ № 2289 от 04.09.2024
                          </span>
                          <br />
                          <span className="rte-standard">
                            В рамках акции «Кредит на большие цели по низкой ставке» по итогам проверки
                            заёмщика: диапазон значений полной стоимости кредита/ займа от 24,9% до 25,67%,
                            процентная ставка по кредиту/ займу составляет: при установлении нескольких
                            ставок для разных периодов срока кредита/ займа - от 25,19% до 25,67% (для
                            кредитов в АО «Кредит Европа Банк (Россия); от 24.9% до 25% (для кредитов в КБ
                            «Ренессанс Кредит» (ООО), АО «ОТП Банк), срок кредита/ займа от 12,18,24 месяцев,
                            сумма кредита/ займа от 2 тыс. 500 рублей до 500 тыс. рублей (для кредитов в АО
                            «Кредит Европа Банк (Россия); срок кредита/ займа от 12,18,24 мес. сумма кредита/
                            займа от 5 тыс. рублей до 1 млн. рублей (для кредитов в КБ «Ренессанс Кредит»
                            (ООО); срок кредита/ займа от 12,18,24 месяцев, сумма кредита/ займа от 2 тыс.
                            рублей до 300 тыс. рублей АО «ОТП Банк»); при
                            установлении нескольких ставок для разных периодов срока кредита/ займа – от 25%
                            до 25%, срок кредита 12,18,24 месяцев, сумма кредита от 3 тыс. рублей до 299 тыс.
                            рублей (для АО «Банк Русский Стандарт»).
                          </span>
                          <br />
                          <span className="rte-standard">
                            Погашение задолженности осуществляется ежемесячными платежами, исходя из срока
                            предоставленного кредита/ займа в соответствии с условиями договора кредита/
                            займа.
                          </span>
                          <br />
                          <span className="rte-standard">
                            * «Кредит на большие цели по низкой ставке» означает, что при приобретении товара
                            с использованием кредитных/ заемных средств указанных банков-партнеров/МФК OOО
                            «ЛЕ МОНЛИД» (ИНН5029069967) предоставляет покупателю скидку на приобретаемый
                            товар в размере 10,0%, в результате чего сумма кредита/займа, выплачиваемая
                            покупателем банку-партнеру/МФК с учетом суммы процентов, превышает первоначальную
                            стоимость товара на 3% при оформлении кредита на 12 месяцев, на 9% при оформлении
                            кредита на 18 месяцев и на 15,5% при оформлении кредита на 24 месяца. При
                            условии, что погашение кредита/ займа осуществляется покупателем в соответствии с
                            графиком платежей, без просрочек, дополнительные услуги банков-партнеров/МФК не
                            приобретаются. Специальное предложение по оплате товаров за счет кредитных/
                            заемных средств, предоставляемых банками-партнерами/МФК, распространяется на
                            товары из отделов: Ванная комната (отделы Сантехника и Плитка), Кухни, Хранение,
                            Входные/межкомнатные двери (отдел Столярные изделия). Подробные условия можно
                            уточнить у продавцов-консультантов и в кредитном отделе.
                          </span>
                          <br />
                          <span className="rte-standard">
                            Правила и условия предоставления кредитов/займов Банками-партнерами в местах
                            оформления кредита/ займа или на сайтах Банков-партнеров www.crediteurope.ru,
                            www.rencredit.ru, www.otpbank.ru, https://www.homecredit.ru, www.otpfinance.ru,
                          </span>
                          <br />
                          <span className="rte-standard">
                            Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения
                            причин отказа. Информация не является офертой.
                          </span>
                        </p>

                        <p>
                          <br />
                        </p>

                        <p>
                          <span className="rte-standard">
                            <b>Кредит на покупку товаров в Лемана ПРО***</b>
                          </span>
                          <br />
                          <span className="rte-standard">
                            Во всех магазинах Лемана ПРО доступны кредитные программы банков-партнёров/МФО на
                            весь ассортимент товаров.
                          </span>
                        </p>
                        <p>
                          <br />
                        </p>
                        <p>
                          <span className="rte-standard">
                            <b>Выберите выгодное условия для покупок</b>
                          </span>
                          <ul>
                            <li>
                              <span className="rte-standard">
                                Диапазон значений полной стоимости кредита от 24,9% до 29,9%
                              </span>
                            </li>
                            <li>
                              <span className="rte-standard">Кредит/заём на срок 6-60 месяцев</span>
                            </li>
                            <li>
                              <span className="rte-standard">
                                Сумма кредита/займа от 2&nbsp;000 рублей до 1&nbsp;000&nbsp;000 рублей
                                (точную сумму уточняйте у кредитного специалиста в магазине, минимальная
                                сумма зависит от выбранного банка)
                              </span>
                            </li>
                            <li>
                              <span className="rte-standard">Первоначальный взнос от 0%.</span>
                            </li>
                          </ul>
                        </p>

                        <p>
                          <span className="rte-standard">
                            <b>Необходимые документы</b>
                          </span>
                          <ul>
                            <li>
                              <span className="rte-standard">Паспорт гражданина РФ</span>
                            </li>
                          </ul>
                          <span className="rte-standard">
                            <b>Требования к заёмщику</b>
                          </span>
                          <ul>
                            <li>
                              <span className="rte-standard">Гражданство Российской Федерации</span>
                            </li>
                            <li>
                              <span className="rte-standard">
                                Постоянная регистрация на территории Российской Федерации
                              </span>
                            </li>
                            <li>
                              <span className="rte-standard">Постоянное место работы</span>
                            </li>
                          </ul>
                        </p>

                        <p>
                          <br />
                        </p>

                        <p>
                          <p>
                          <span className="rte-standard">
                            <b>*** Кредит</b>
                          </span>
                          </p>
                          <span className="rte-standard">
                            Кредит /заем на покупку товаров в Лемана ПРО предоставляют: АО «Кредит Европа
                            Банк (Россия)», универсальная лицензия ЦБ РФ на осуществление банковских операций
                            № 3311 от 03.09.2019 г.; КБ «Ренессанс Кредит» (ООО), лицензия Банка России на
                            осуществление банковских операций № 3354 от 26.04.2013 г.; АО «ОТП Банк»,
                            лицензия на осуществление банковских операций № 2766 от 27.11.2014 г.; АО «Банк Русский Стандарт»
                            лицензия ЦБ РФ № 2289 от 04.09.2024; ООО МФК «ДК ПЭЙ», свидетельство о внесении сведений о юридическом лице в государственный реестр микрофинансовых организаций от 27.12.2023.
                          </span>
                          <p></p>
                          <span className="rte-standard">
                            В рамках акции «Кредит/ заем на покупку товаров в Лемана ПРО» по итогам проверки
                            заёмщика: диапазон значений полной стоимости кредита от 24,0% до 26,8% (для
                            кредитов АО «Кредит Европа Банк (Россия)»); 25% (для кредитов в КБ «Ренессанс
                            Кредит» (ООО), 29,0%-34,0%т АО «ОТП Банк»; 30% для ООО МФК «ДК ПЭЙ; срок кредита/ займа от 6-36 месяцев,
                            сумма кредита/ займа от 2 тыс. 500 рублей до 750 тыс. рублей (для кредитов в АО
                            «Кредит Европа Банк (Россия); срок кредита/ займа от 6-24 месяцев, сумма кредита/
                            займа от 5 тыс. рублей до 1 млн. рублей (для кредитов в КБ «Ренессанс Кредит»
                            (ООО); срок кредита/ займа от 6-12 месяцев, сумма кредита/ займа от 5 тыс. рублей до 200 тыс. рублей (для кредитов ООО МФК «ДК ПЭЙ); 
                            срок кредита/ займа от 6-36 месяцев, сумма кредита/ займа от 2 тыс. рублей
                            до 300 тыс. рублей АО «ОТП Банк»); при
                            установлении нескольких ставок для разных периодов срока кредита/ займа – от 29%
                            до 29%, срок кредита 6-36 месяцев, сумма кредита от 3 тыс. рублей до 299 тыс.
                            рублей (для АО «Банк Русский Стандарт»).
                          </span>
                          <p></p>
                          <span className="rte-standard">
                            Погашение задолженности осуществляется ежемесячными платежами, исходя из срока
                            предоставленного кредита/ займа в соответствии с условиями договора кредита/
                            займа.
                          </span>
                          <p></p>
                          <span className="rte-standard">
                            Кредит/заем предоставляется на весь ассортимент товаров Лемана ПРО. Правила
                            покупки в кредит/ заем в местах оформления кредита/ займа или на сайтах банков
                            www.crediteurope.ru, www.rencredit.ru, www.otpbank.ru, www.otpfinance.ru
                          </span>
                          <p></p>
                          <span className="rte-standard">
                            Банк имеет право отказать клиенту в предоставлении кредита/ займа без объяснения
                            причин отказа.
                          </span>
                        </p>

                        <p>
                          <br />
                        </p>

                        <p>
                          <p>
                          <span className="rte-standard">
                            <b>Способы погашения кредита/займа</b>
                          </span>
                          </p>
                          <span className="rte-standard">
                            Каналы погашения <b>без комиссии</b>
                          </span>
                          <ul>
                            <li>
                              <span className="rte-standard">
                                Перевод по номеру телефона через систему быстрых платежей (СБП)
                              </span>
                            </li>
                            <li>
                              <span className="rte-standard">
                                Перевод денег через отделения почтовой связи АО «Почта России» почтовым
                                отправлением
                              </span>
                            </li>
                            <li>
                              <span className="rte-standard">Каналы погашения банков-партнёров****</span>
                            </li>
                          </ul>
                        </p>

                        <p>
                          <span className="rte-standard">
                            <b>Важно:</b>
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            1. <b>ОЦЕНИВАЙТЕ СВОИ ФИНАНСОВЫЕ ВОЗМОЖНОСТИ И РИСКИ</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            2. Кредит/заём можно <b>погасить</b> частично или полностью <b>досрочно</b>: в
                            любой момент в течение срока кредитного договора/договора займа, без
                            дополнительных комиссий.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            3. Товар, приобретённый в кредит/заём, можно <b>вернуть</b> в соответствии с
                            условиями <a href="/service/vozvrat-tovara/">возврата</a> и обмена товара.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            4. За рассмотрение заявления на кредит/заём и выдачу кредита/займа{' '}
                            <b>комиссия не взимается</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            5. В выбранных магазинах Лемана ПРО можно оформить кредит/заём на товар и услугу
                            по его <b>установке и доставке</b>.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            6. Предложение по кредитам действует только при покупке товаров в магазинах
                            Лемана ПРО.
                          </span>
                        </p>
                        <p>
                          <span className="rte-standard">
                            7. Предложение не действует при заказе товаров через{' '}
                            <a href="/">интернет-магазин Лемана ПРО</a> и мобильное приложение Лемана ПРО.
                          </span>
                        </p>

                        <p>&nbsp;</p>
                        <p>
                          <span className="rte-standard">
                            Банк/МФО имеет право отказать клиенту в предоставлении кредита/займа без
                            объяснения причин отказа. Информация не является офертой.
                          </span>
                        </p>
                        <p>
                          **** С информацией о каналах погашения кредитов/займов банков/МФО-партнёров вы
                          сможете ознакомиться в магазинах Лемана ПРО в кредитном отделе и на сайтах банков
                          или МФО-партнёров.
                        </p>
                        <p>
                          ***** Информацию по возможности оформления услуг в кредит/заём уточняйте в вашем
                          магазине.
                        </p>

                        <p>
                          Информация по кредитным продуктам, указанная на данной странице, предоставлена: ООО
                          «Кредит консалтинг» (ОГРН 1077760014111, ИНН 7733621690), ООО «Кредитные Системы»
                          (ОГРН 1167746335833, ИНН 7719443075), ООО «Директ Кредит Центр» (ОГРН 1157746356690, ИНН 7701327127) которые отвечают за формирование и
                          сопровождение указанных кредитных программ по заказу ООО «ЛЕ МОНЛИД», в
                          соответствии с договорами на брокерское обслуживание.
                        </p>
                        <p>&nbsp;</p>

                        <div className="text parbase section">
                          <SplitDescription />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </MainLayout>
  );
};
